import { Component, OnInit } from '@angular/core';
import { EditorInputField, Site } from '../../../../editor-container/editor-model';
import { PreviewEditStoreService } from '../../../../../lib/services/preview-edit-store.service';
import { ThemeEditorStoreService } from '../../theme-editor-store.service';

@Component({
  selector: 'kve-colours',
  templateUrl: './colours.component.html',
  styleUrls: ['./colours.component.scss']
})
export class ColoursComponent implements OnInit {

  fields:EditorInputField[] = [
    {
      name:"primaryColor",
      title:"Primary Colour",
      type:"theme",
      controlType:"theme-color-picker"
    },
    {
      name:"pageBgColor",
      title:"Page Background",
      type:"theme",
      controlType:"theme-color-picker"
    },
    {
      name:"layoutTextColor",
      title:"Text Color",
      type:"theme",
      controlType:"theme-color-picker"
    }
  ]
/*   themes = [
    {
      id:1,
      value: 'default',
      name: 'Default',
      pallette:'#3366ff',
    },
    {
      id:2,
      value: 'green-house',
      name: 'Green House',
      pallette:"#8CA52E"
    },
    {
      id:3,
      value: 'navy-kadet',
      name: 'Navy Kadet',
      pallette:"#192A53"
    },
    {
      id:4,
      value: 'earthtone',
      name: 'Earth Tone',
      pallette:"#B73225"
    },
    {
      id:5,
      value: 'makeup',
      name: 'Makeup',
      pallette:"#DDAF94"
    },
    {
      id:6,
      value: 'blackish',
      name: 'Blackish',
      pallette:"#202020"
    },
    {
      id:7,
      value: 'cactus',
      name: 'Cactus',
      pallette:"#74AC67"
    },
    {
      id:8,
      value: 'olive-tree',
      name: 'Olive Tree',
      pallette:"#77A19B"
    },
    {
      id:9,
      value: 'citric-acid',
      name: 'Citric Acid',
      pallette:"#FE7C02"
    },
    {
      id:10,
      value: 'wind-swept',
      name: 'Wind Swept',
      pallette:"#AB9390"
    },
    {
      id:11,
      value: 'fools-gold',
      name: 'Fools Gold',
      pallette:"#FFC507"
    },
    {
      id:12,
      value: 'skyroof',
      name: 'Skyroof',
      pallette:"#87CEEB"
    },
    {
      id:13,
      value: 'riding-hood',
      name: 'Ridinghood',
      pallette:"#FF0000"
    }
  ];

  colors:string[] = [];

  color = "#FFF";

  themeVariables$:Subscription;

  destroy$ = new Subject<void>(); */

  constructor(
    private previewEditStore:PreviewEditStoreService,
    private themeEditorStore:ThemeEditorStoreService) { }

  ngOnInit(): void {
    this.previewEditStore.selectedSite$.subscribe((site:Site) => {
      if(site.theme != undefined){
        this.themeEditorStore.init(site.theme)
      }
    })
    /* this.themeVariables$ = this.communicator.receive("themeVariables").pipe(takeUntil(this.destroy$))
    .subscribe((data:any) => {
      let themeOptions = data.data;
      let name = themeOptions.name;
      let themeVariables = themeOptions.variables;
      //console.log(themeVariables)
      this.color = themeVariables.primary;
      console.log(this.color)
    })
    this.themes.forEach(theme => {
      this.colors.push(theme.pallette);
    }) */
  }

  /* handleChangeComplete(e){

  } */

}
